// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"266":"7d3f20ad","893":"780c0151"}[chunkId] + ".chunk.css";
};